import React,{useEffect, useState} from 'react'
import createComponent from '@services/react-mount-component'
import useSections from '@hooks/use-sections'

function pad(n, width=2, z='0') {
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export default createComponent('.section-indicator',
  ({
    labelPadding=2
  }) => {
    const [activeIndex,elements] = useSections();
    const [isWhite,setIsWhite] = useState(false);

    useEffect(
      ()=>{
        let mounted = true;

        const handleChange = e=>{
          const section = e.detail.elements[e.detail.currentIndex];
          setIsWhite(
            section.classList.contains('is-dark') ||
            section.classList.contains('is-secondary')
          );
        }
        document.addEventListener('sections:change',handleChange);

        return ()=>{
          mounted = false;
          document.removeEventListener('sections:change',handleChange);
        }
      }
      ,[setIsWhite]
    );

    return (
      <div className={isWhite?'is-inverted' : ''}>
        <div className="section-indicator-track">
          <div>
            {
              elements.map((element,index) => (
                <div key={index} className={`section-indicator-label ${index===activeIndex?'label-current':''}`}>
                  {pad(index+1,labelPadding)}
                </div>
              ))
            }
          </div>
        </div>
        <div className="section-indicator-label label-total">{pad(elements.length,labelPadding)}</div>
      </div>
    )
  }
);